import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import FloatingButtons from "./FloatingButtons";
import { useAuth } from "../../contexts/AuthContext";

export default function GetVerified() {
  const { currentUser } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <FloatingButtons />
      <section className="cs-bg-dark py-4 cs-section">
        <div className="container">
          <Row className="mb-4">
            <Col>
              <Row className="mt-4">
                <Col>
                  <h1 className="text-white mb-0">
                    BBR RENTER VERIFICATION
                  </h1>
                  <p className="text-white mb-2">
                    Verification for renter-operated boats — Bass Boats,
                    Pontoons, Wake Boats, Jet Skis, Fishing Boats and more.
                  </p>
                  <h4 className="text-white">
                    Only the person operating the boat needs to be verified
                  </h4>
                  <div className="text-white pb-3">
                    <p>
                      When you rent a boat through BBR, the boat owner is
                      trusting you with one of their most valuable assets.
                      Getting verified helps give the owner confidence that you
                      have experience operating a similar type of vessel.
                    </p>
                    <p>
                      BBR Renter Verification allows you to provide details
                      about your boating experience, the types and sizes of
                      vessels you have operated, and your experience with
                      similar equipment.
                    </p>
                    <p>
                      We strongly recommend getting verified before requesting
                      or booking a renter-operated boat. A verified profile can
                      help boat owners feel more comfortable accepting your
                      booking and shows that you have taken the time to
                      demonstrate your boating experience.
                    </p>
                    <p>
                      Verification is specific to your experience. Operating a
                      bass boat, pontoon, wake boat, center console, or personal
                      watercraft can require very different skills, so we may
                      ask additional questions depending on the type of boat you
                      want to rent.
                    </p>
                    <p>
                      Once verified for a particular vessel category, your
                      verification becomes part of your BBR renter profile and
                      can help you with future rentals of similar boats.
                    </p>
                    <p>
                      New to boating or don&apos;t have enough experience yet?
                      That&apos;s okay. Many BBR listings are available with
                      experienced captains and fishing guides, allowing you to
                      enjoy the boat without operating it yourself.
                    </p>
                    <p className="mb-0">
                      Get verified now and be ready when you find the right
                      boat.
                    </p>
                  </div>
                  <Link
                    to={
                      currentUser
                        ? "/dashboard/get-verified"
                        : "/auth/signup-renter"
                    }
                    className="btn btn-light"
                  >
                    Get Verified
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}
